export default __webpack_public_path__ + "locales/uk-UA/Files.json?hash=1419ef47161c7e8f58d08f586b0a1eb1";